import { http } from "../../drivers/data";
import "./locales";
import { country } from "./services";

http.events.beforeSending(options => {
  if (country.exists) {
    options.headers.country = country.code;
  }
});
